import useUrlParams from './useUrlParams'
import { isSmava } from '../utils/getTenantInfo.utils'
import {
  getAdvertisementId,
  getRefId,
  mapQueryParamsToTeal,
} from '../utils/url'
import { EntryPoint } from '../utils/entryPoint.enum'

export const IMOD_CONTAINER_ID = 'imod'

interface UseEmbedObjectArgs {
  formConfig?: string
  palette?: any
}

const useEmbedObject = ({ formConfig, palette }: UseEmbedObjectArgs = {}) => {
  const queryParams = useUrlParams()
  const {
    resume,
    subId,
    amount,
    term,
    purpose,
    productId,
    vehiclePrice,
    initialPayment,
    bankpartner,
    embedded,
    entryPoint,
    backUrl,
    formConfig: qpFormConfig,
    hasDac,
  } = mapQueryParamsToTeal(queryParams)

  const advertisementId = getAdvertisementId(queryParams)

  // To fix the issue of conversions from one affiliate being allocated to other affiliates
  // https://jira.atl.finanzcheck.de/browse/ANCH-591
  const refId = getRefId(queryParams)

  // parameters which can be used in all circumstances
  let data = {
    ...(resume && { resume }),
    ...(subId && { subId }),
    formConfig: qpFormConfig || formConfig || (isSmava ? 'ddf_smava' : 'ddf'),
    ...(palette && { palette }),
    ...(refId && { refId }),
    ...(embedded && { embedded }),
  }

  // loan related content should only be overriden if there isn't a resume to be performed
  if (!resume) {
    data = {
      ...data,
      ...(amount && { amount }),
      ...(term && { term }),
      ...(purpose && { purpose }),
      ...(vehiclePrice && { vehiclePrice }),
      ...(initialPayment && { initialPayment }),
      ...(productId && { productId }),
      ...(bankpartner && { bankpartner }),
    }
  }

  return {
    elementId: IMOD_CONTAINER_ID,
    advertisementId,
    data,
    entryPoint: entryPoint ?? EntryPoint.First,
    ...(backUrl && { backUrl }),
    embedImodLp: false, // Remove once both PR on widget and imodlp is in production
    imodEntryPoint: 'taurine',
    ...(hasDac && { hasDac }),
  }
}

export default useEmbedObject
